import { render, staticRenderFns } from "./sub-layout.vue?vue&type=template&id=0347f21c&scoped=true"
import script from "./sub-layout.vue?vue&type=script&lang=js"
export * from "./sub-layout.vue?vue&type=script&lang=js"
import style0 from "./sub-layout.vue?vue&type=style&index=0&id=0347f21c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0347f21c",
  null
  
)

export default component.exports